<template>
  <div>
    <p v-if="title !== false" class="mb-4 text-lg font-semibold">
      {{ title ?? "Ce que vous retrouverez" }}
    </p>

    <ul class="flex max-w-[800px] flex-wrap gap-x-6 gap-y-3 xl:flex-nowrap">
      <li
        v-for="item in list"
        :key="item.icon"
        class="flex basis-[calc(100%/var(--count))] items-center gap-3 text-balance"
        :style="{ '--count': list.length }"
      >
        <app-icon
          class="!h-6 !w-6 xl:!h-10 xl:!w-10"
          :icon="item.icon"
          :size="42"
        />
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

defineProps<{
  list: { label: I18nMessage; icon: string }[];
  title?: I18nMessage | false;
}>();
</script>
